import React from 'react';
import { useTranslation } from 'react-i18next';
import { namespaces } from 'i18n/i18n.constants';
import { RippleButton } from '@isyc-react/form/modules/base';
import { DossierDocumentsContainer } from '../doc-group';
import './dossier-selector.style.scss';
export const DossierSelector = props => {
    const { dossiers } = props;
    const { t } = useTranslation(namespaces.common);
    const [dossier, setDossier] = React.useState(dossiers.length === 1 ? dossiers[0] : null);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'container text-center py-5 mt-4 mb-4' },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-12' },
                    React.createElement("p", { className: 'font-size-18 mb-5' }, t('appMainWelcomeInfo')),
                    dossiers.length > 1 && (React.createElement("div", { className: 'dossier-select-container' }, dossiers.map(item => (React.createElement(React.Fragment, { key: item.id },
                        React.createElement(RippleButton, { className: 'btn btn-lg btn-outline-primary m-1', onClick: () => {
                                setDossier(item);
                            }, disabled: item.id === (dossier === null || dossier === void 0 ? void 0 : dossier.id) },
                            React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                                React.createElement("div", null,
                                    item.name,
                                    " (",
                                    item.id,
                                    ") - ",
                                    item.dossierTemplate.name))))))))))),
        dossiers.length === 0 && (React.createElement("div", { className: 'd-flex justify-content-center align-items-center mb-4', style: { height: '500px' } },
            React.createElement("p", null, "Il n'y a pas de dossiers disponibles pour le t\u00E9l\u00E9chargement de documents"))),
        dossier && React.createElement(DossierDocumentsContainer, { dossier: dossier })));
};
